export const Property = {
    Money: {
        cash: '現金(円)',
        storageLocation: '現金の保管場所',
    },
    Deposit: {
        depositSaving: '預貯金(円)',
        bankName: '銀行名',
        branchName: '支店名',
        accountType: '口座種類',
        accountNumber: '口座番号',
        accountName: '名義'
    },
    Land: {
        whereabouts: '所在',
        lotNumber: '地番',
        ground: '地目',
        realEstate: '地積'
    },
    Building: {
        whereabouts: '所在',
        houseNumber: '家屋番号',
        type: '種類'
    },
    Apartment: {
        whereabouts: '所在',
        buildingName: '建物の名称'
    },
    Stock: {
        brand: '銘柄',
        quantity: '数量',
        financialInstitution: '取扱金融機関',
        accountNumber: '口座番号',
        totalEvaluationValue: '現在の評価額合計'
    },
    Fund: {
        brand: '銘柄',
        quantity: '数量',
        financialInstitution: '取扱金融機関',
        accountNumber: '口座番号',
        totalEvaluationValue: '現在の評価額合計'
    },
    Insurance: {
        company: '保険会社',
        type: '保険の種類',
        policyNumber: '保険証券番号'
    },
    Bond: {
        type: '債権の種類',
        bondor: '債務者',
        amountMoney: '金額'
    },
    Debt: {
        type: '債権の種類',
        debtor: '債務者',
        amountMoney: '金額'
    },
    Automobile: {
        registrationNumber: '登録番号',
        type: '種別',
        name: '車名'
    },
    Other: {
        discipline: '種目',
        custodyLocation: '保管者または所在地',
        quantity: '数量',
        valuation: '評価額(円)'
    }
}
